"use strict"
angular.module("manageSysOneKeyWithdrawModule", [
        'manageSysOneKeyWithdrawRouterModule',
        'manageSysOneKeyWithdrawLogModule',
        'manageSysOneKeyWithdrawDetailModule'
    ])
    .controller("oneKeyWithdrawCtrl", ['$scope', '$filter', 'trsHttpService', '$q', '$stateParams', '$state', 'modalDialog', 'trsspliceString','previewService', 'storageListenerService', function($scope, $filter, trsHttpService, $q, $stateParams, $state, modalDialog, trsspliceString, previewService, storageListenerService) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                PAGECOUNT: 0,
                ITEMCOUNT: 0,
            };
            $scope.status = {
                channels: [{
                    name: '客户端',
                    value: 1,
                }, {
                    name: '网站',
                    value: 2
                }],
                selectedChannel: {
                    name: '客户端',
                    value: 1,
                },
                sites: [],
                selectedSites: [],
                copyCurrPage: 1,
            };
            $scope.data = {
                AllKeywords: [],
                ArbitrarilyKeywords: [],
                AllKeywordsTips: '',
                ArbitrarilyKeywordsTips: '',
                isShowAllKeywordsTips: false,
                isShowArbitrarilyKeywordsTips: false,
                items: [],
                selectedArray: [],
                docIdNot: [],
            };
            $scope.currdata = {};
            $scope.currstatus = {};
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            // $scope.data.items = $scope.fake.DATA;
            // $scope.page.ITEMCOUNT = $scope.fake.PAGER.ITEMCOUNT;
            // $scope.page.PAGECOUNT = $scope.fake.PAGER.PAGECOUNT;
            initSites().then(() => {
                $scope.currstatus = angular.copy($scope.status);
                requestData();
            })
        }

        /**
         * [requestData 请求数据]
         *
         */
        function requestData() {
            $scope.data.selectedArray = [];
            $scope.data.items = [];
            $scope.params = getSearchParams();
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                $scope.page.PAGESIZE = data.PAGER.PAGESIZE;
                $scope.data.items = data.DATA;
                for (var i in $scope.data.items)
                    $scope.data.selectedArray.push($scope.data.items[i]);
            });
        }
        /**
         * [dateFormat description] 日期整理
         * @param  {[Date]} date    [description] 日期
         * @return {[type]}         [description]
         */
        function dateFormat(date) {
            if (!date) return "";
            return $filter('date')(date, 'yyyy-MM-dd HH:mm:ss');
        }
        /**
         * [setPageCheck description] 跨页isChecked设置
         */
        $scope.setPageCheck = function(item) {
            let flag1 = $scope.data.docIdNot.every(item_ => {
                return item_.CHNLDOCID != item.CHNLDOCID;
            });
            let flag2 = $scope.data.selectedArray.some(item_ => {
                return item_.CHNLDOCID == item.CHNLDOCID;
            });
            return flag1 && flag2;
        }
        /**
         * [selectPageNum description] 选择一页要显示的数据量
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            $scope.status.copyCurrPage = 1;
            requestData();
        };
        /**
         * [pageChanged description] 下一页 页面改变调取数据
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
            // console.log($scope.data.docIdNot);
        };
        /**
         * [jumpToPage description] 跳转页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };
        /**
         * [getSearchParams description] 设置参数
         */
        function getSearchParams() {
            var gsParams = {
                serviceid: "mlf_withdrawdoc",
                methodname: "querySignedDoc",
                mediaType: $scope.currstatus.selectedChannel.value ? $scope.currstatus.selectedChannel.value : 1,
                searchparams: {
                    "PAGESIZE": $scope.page.PAGESIZE + "",
                    "PAGEINDEX": $scope.page.CURRPAGE + "",
                    "searchFields": [{
                        "searchField": "keywordsOr",
                        "keywords": $scope.currdata.ArbitrarilyKeywords ? trsspliceString.spliceString($scope.currdata.ArbitrarilyKeywords, "name", ',') : ""
                    }, {
                        "searchField": "keywordsAnd",
                        "keywords": $scope.currdata.AllKeywords ? trsspliceString.spliceString($scope.currdata.AllKeywords, "name", ',') : ""
                    }, {
                        "searchField": "timeType",
                        "keywords": ($scope.currdata.startTime) ? dateFormat($scope.currdata.startTime) + ',' + dateFormat($scope.currdata.endTime ? $scope.currdata.endTime : new Date()) : ""
                    }, {
                        "searchField": "siteId",
                        "keywords": $scope.currstatus.selectedSites ? trsspliceString.spliceString($scope.currstatus.selectedSites, 'value', ',') : trsspliceString.spliceString($scope.currstatus.sites, 'value', ',')
                    }, {
                        "searchField": "docIdNot",
                        "keywords": $scope.data.docIdNot ? trsspliceString.spliceString($scope.data.docIdNot, "METADATAID", ',') : ""
                    }, {
                        "searchField": "siteNames",
                        "keywords": $scope.currstatus.selectedSites ? trsspliceString.spliceString($scope.currstatus.selectedSites, 'name', ',') : trsspliceString.spliceString($scope.status.sites, 'name', ',')
                    }, {
                        "searchField": "_sort",
                        "keywords": $scope.currdata.sortType ? $scope.currdata.sortType : "CRTIME"
                    }]
                }
            };
            //  console.log(gsParams);
            gsParams.searchparams = JSON.stringify(gsParams.searchparams);
            return gsParams;
        }
        /** 
         * [initSites description] 获取站点
         */
        function initSites(){
            $scope.status.sites = [];
            let deffer = $q.defer();
            let siteParams = {
                serviceid: "mlf_withdrawdoc",
                methodname: "queryWebsites",
                mediaType: $scope.status.selectedChannel.value ? $scope.status.selectedChannel.value : 1
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), siteParams, 'get').then(function(data) {
                $scope.status.sites = data.map((item, index) => {
                    return {
                        name: item.SITENAME,
                        value: item.SITEID
                    }
                });
                $scope.status.selectedSites = angular.copy($scope.status.sites);
                deffer.resolve();
            });
            return deffer.promise;
        }
        /** 
         * [getSites description] 获取站点
         */
        $scope.getSites = function(selectedChannelValue) {
            let deffer = $q.defer();
            let siteParams = {
                serviceid: "mlf_withdrawdoc",
                methodname: "queryWebsites",
                mediaType: selectedChannelValue
            };
            $scope.status.sites = [];
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), siteParams, 'get').then(function(data) {
                $scope.status.sites = data.map((item, index) => {
                    return {
                        name: item.SITEDESC,
                        value: item.SITEID
                    }
                });
                $scope.status.selectedSites = angular.copy($scope.status.sites);
                deffer.resolve();
            });
            return deffer.promise;
        }
        /**
         * [search description] 检索
         */
        $scope.search = function() {
            $scope.currdata = angular.copy($scope.data);
            $scope.currstatus = angular.copy($scope.status);
            requestData();

        }
        /**
         * [setAllCheck desciption] 站点全选
         */
        $scope.setAllCheck = function(){
            if($scope.status.selectedSites.length == $scope.status.sites.length){
                $scope.status.selectedSites = [];
            }
            else
            {
                $scope.status.selectedSites = [];
                for(var i in $scope.status.sites){
                    $scope.status.selectedSites.push($scope.status.sites[i]);
                }
            }
        }
        /**
         * [setCheck description] 下拉列表勾选
         */
        $scope.setCheck = function(item) {
            let result = $scope.siteIsSelected(item);
            if (result.flag) {
                $scope.status.selectedSites.splice(result.index, 1)
            } else {
                $scope.status.selectedSites.push(item);
            }
        }
        /**
         * [siteIsSelected description] 站点是否被选中
         * @param  {[type]} option [description] 被校验的站点
         * @return {[type]}        [description]
         */
        $scope.siteIsSelected = function(option) {
            let result = {
                flag: false
            };
            if ($scope.status.sites.length == 0) return result;
            for (let i in $scope.status.selectedSites) {
                let item = $scope.status.selectedSites[i];
                if (item.value == option.value) {
                    return {
                        flag: true,
                        index: i
                    };
                }
            }
            return result;
        };
        /**
         * [singleSelect 单选]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.singleSelect = function(item) {
            let index1 = $scope.data.selectedArray.findIndex(item_ => {
                return item_.CHNLDOCID == item.CHNLDOCID;
            });
            let index2 = $scope.data.docIdNot.findIndex(item_ => {
                return item_.CHNLDOCID == item.CHNLDOCID;
            });
            index1 > -1 ? $scope.data.selectedArray.splice(index1, 1) : $scope.data.selectedArray.push(item);
            index2 > -1 ? $scope.data.docIdNot.splice(index2, 1) : $scope.data.docIdNot.push(item);
        };
        /**
         * [setPageAllCheck description] 跨页全选判断
         */
        $scope.setPageAllCheck = function() {
            let flag1 = $scope.data.items.every(item => { //判断稿件是否全部没选中
                let chnlDocIdArray = $scope.data.docIdNot.map(item_ => { //当页稿件的chnldocid集合
                    return item_.CHNLDOCID;
                });
                return chnlDocIdArray.indexOf(item.CHNLDOCID) < 0;
            });
            return flag1 && $scope.data.items.length > 0 && $scope.data.selectedArray.length == $scope.data.items.length;
        }
        /**
         * [selectAll 全选]
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            if ($scope.setPageAllCheck()) {
                $scope.data.selectedArray = [];
                $scope.data.items.forEach(item => {
                    let flag = $scope.data.docIdNot.some(item_ => {
                        return item.CHNLDOCID == item_.CHNLDOCID;
                    });
                    if (!flag) {
                        $scope.data.docIdNot.push(item);
                    }
                });
            } else {
                $scope.data.selectedArray = angular.copy($scope.data.items);
                outerLoop: for (let i in $scope.data.items) {
                    let item = $scope.data.items[i];
                    for (let j = $scope.data.docIdNot.length - 1; j >= 0; j--) {
                        let item_ = $scope.data.docIdNot[j];
                        if (item.CHNLDOCID == item_.CHNLDOCID) {
                            $scope.data.docIdNot.splice(j, 1);
                            continue outerLoop;
                        }
                    }
                }
            }
        };
        /** [release description] 撤稿
         *
         */
        $scope.release = function() {
            modalDialog.alertType('稿件撤稿后无法重新发布稿件，是否继续？', "", "ask", true, function() {
                let deffer = $q.defer();
                let releaseParams = {
                    serviceid: "mlf_withdrawdoc",
                    methodname: "withdrawDoc",
                    mediaType: $scope.currstatus.selectedChannel.value ? $scope.currstatus.selectedChannel.value : 1,
                    searchparams: {
                        "PAGESIZE": $scope.page.PAGESIZE + "",
                        "PAGEINDEX": $scope.page.CURRPAGE + "",
                        "searchFields": [{
                            "searchField": "keywordsOr",
                            "keywords": $scope.currdata.ArbitrarilyKeywords ? trsspliceString.spliceString($scope.currdata.ArbitrarilyKeywords, 'name', ',') : ""
                        }, {
                            "searchField": "keywordsAnd",
                            "keywords": $scope.currdata.AllKeywords ? trsspliceString.spliceString($scope.currdata.AllKeywords, 'name', ',') : ""
                        }, {
                            "searchField": "timeType",
                            "keywords": ($scope.currdata.startTime) ? dateFormat($scope.currdata.startTime) + ',' + dateFormat($scope.currdata.endTime ? $scope.currdata.endTime : new Date()) : ""
                        }, {
                            "searchField": "siteId",
                            "keywords": $scope.currstatus.selectedSites ? trsspliceString.spliceString($scope.currstatus.selectedSites, 'value', ',') : ''
                        }, {
                            "searchField": "docIdNot",
                            "keywords": $scope.data.docIdNot ? trsspliceString.spliceString($scope.data.docIdNot, "METADATAID", ',') : ""
                        }, {
                            "searchField": "siteNames",
                            "keywords": $scope.currstatus.selectedSites ? $scope.currstatus.selectedChannel.name + ':' + ($scope.currstatus.sites.length == $scope.currstatus.selectedSites.length ? '全部' : trsspliceString.spliceString($scope.status.selectedSites, 'name', ',') ): ''
                        }, {
                            "searchField": "_sort",
                            "keywords": $scope.currdata.sortType ? $scope.currdata.sortType : "CRTIME"
                        }]
                    }
                };
                releaseParams.searchparams = JSON.stringify(releaseParams.searchparams);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), releaseParams, 'post').then(function(data) {
                    modalDialog.alertType(data.DETAIL, '', 'success', false, function() {
                        $scope.data.docIdNot = [];
                        requestData();
                    })
                    deffer.resolve();
                })
                return deffer.promise;
            });
        }
        $scope.openDetail = function(item){
            if($scope.currstatus.selectedChannel.value ==1){
                var editPath = 'appPreview';
                var editParams = {
                    appsiteid: item.SITEID,
                    appmetadataid: item.METADATAID,
                    appchannelid: item.CHANNELID,
                    appchnldocid: item.CHNLDOCID,
                    // appplatform: 2,
                    appdoctype: item.DOCTYPEID-1,
                    // newspapertype: $scope.status.sbgpreview
                };
                var websiteUrl = $state.href(editPath, editParams);
                // selectedArrayCahe($scope.data.selectedArray);
                window.open(websiteUrl);
            }
            else{
                var router = '#/websitepreview?' + 
                'wzchannelid=' + item.CHANNELID + '&' +
                'wzsiteid=' + item.SITEID + '&' +
                'wzchnldocid=' + item.CHNLDOCID + '&' +
                'wzmetadataid=' + item.METADATAID + '&' +
                'wztypeid=' + item.DOCTYPEID 
                // + '&' +'wzplatform=0';
                window.open(router);
            }
        }
       
        /**
         * [invalidTag 增加时做重复校验]
         * @param  {[type]} tag   [description]
         * @param  {[type]} field [description]
         * @return {[type]}       [description]
         */
        $scope.tagChange = function(tag, field) {
            var flag = false;
            for (var i in $scope.data[field]) {
                if ($scope.data[field][i].name === tag) {
                    flag = true;
                    break;
                }
            }
            if (flag) {
                $scope.data['isShow' + field + 'Tips'] = true;
                $scope.data[field + 'Tips'] = "关键词不能重复";
            } else {
                $scope.data['isShow' + field + 'Tips'] = false;
            }
        };

        $scope.leave = function() {
            // $scope.data.isShowAllKeywordsTips = false;
            // $scope.data.isShowArbitrarilyKeywordsTips = false;
        };

        /**
         * [监听时间]
         * @param  {[type]} newV  [description]
         * @param  {[type]} oldV) {                       if (newV.startTime && newV.endTime) {                if (newV.startTime.getTime() > newV.endTime.getTime()) {                    modalDialog.alertType('开始时间不能大于结束时间', '', 'info');                    $scope.data.startTime [description]
         * @param  {[type]} true  [description]
         * @return {[type]}       [description]
         */
        $scope.$watch('data', function(newV, oldV) {
            if(newV.startTime){
                let currTime = new Date();
                if(newV.startTime>currTime){
                    modalDialog.alertType('选择时间不能为当前时间之后','','info','confirm',function(){
                        $scope.data.startTime = currTime;
                    });
                }
            }
            if(newV.endTime){
                let currTime = new Date();
                if(newV.endTime > currTime){
                    modalDialog.alertType('选择时间不能为当前时间之后','','info','confirm',function(){
                        $scope.data.endTime = currTime;
                    });
                }
            }
            if (newV.startTime && newV.endTime) {
                if (newV.startTime > newV.endTime) {
                    if(newV.startTime.getDate() == newV.endTime.getDate()&&newV.startTime.getMonth() == newV.endTime.getMonth()){
                        $scope.data.endTime = $scope.data.startTime;
                    }
                    modalDialog.alertType('开始时间不能大于结束时间', '', 'info', 'confirm', function() {
                        $scope.data.endTime = $scope.data.startTime;
                    });
                }
            }
        }, true);
    }]);